import { jsx } from 'react/jsx-runtime';
import styles from './BottomButton.module.scss.js';
import { Button } from '../../ui/button.js';
import { useKeyboardScroll } from '../../../hooks/use-keyboard-scroll.js';
import { cn } from '../../../lib/utils.js';

const BottomButtons = ({
  type = "full",
  position = "fixed",
  buttons,
  ...props
}) => {
  const { isKeyboardOpen } = useKeyboardScroll();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        styles["bottom-button-wrapper"],
        position === "relative" && "!relative",
        isKeyboardOpen ? styles["keyboard-open"] : ""
      ),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            styles["bottom-button-inner"],
            position === "relative" && "!px-0 !pt-10 !pb-0",
            type === "focus" && "flex-glow"
          ),
          children: buttons.map((btn, idx) => /* @__PURE__ */ jsx(
            Button,
            {
              variant: btn.Variants === "secondary" ? "scOutline" : btn.Variants === "brand" ? "brand" : "default",
              size: "lg",
              className: cn(
                styles["bottom-button"],
                "whitespace-normal !outline-offset-4",
                type === "focus" && btn.Variants === "secondary" && "!flex-[0_0_48.8%]",
                type === "focus" && btn.Variants === "primary" && "!flex-1",
                btn.hideDesktop ? "md:hidden" : ""
              ),
              onClick: btn.onClick,
              disabled: btn.disabled,
              ref: btn.ref,
              ...props,
              children: btn.label
            },
            idx
          ))
        }
      )
    }
  );
};

export { BottomButtons };
